import { c as _c } from "react/compiler-runtime";
import { parseAsInteger, useQueryState } from 'nuqs';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
export type HelpMeChooseFooterProps = {
  backwardsLabel?: string;
  backwardsClick?: () => void;
  forwardLabel?: string;
  forwardVariant?: 'primary' | 'secondary';
  forwardIcon?: React.ReactNode;
  forwardClick?: () => void;
};
export const HelpMeChooseFooter: React.FC<HelpMeChooseFooterProps> = t0 => {
  const $ = _c(17);
  const {
    backwardsLabel,
    backwardsClick,
    forwardLabel,
    forwardVariant,
    forwardIcon,
    forwardClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = parseAsInteger.withDefault(0);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [step] = useQueryState("step", t1);
  let t2;
  if ($[1] !== backwardsClick || $[2] !== backwardsLabel || $[3] !== step) {
    t2 = step > 0 && <ButtonStyle purpose="neutral" variant="secondary" size="md" fullWidth={true}><button className="w-full" type="button" onClick={backwardsClick}>{backwardsLabel}</button></ButtonStyle>;
    $[1] = backwardsClick;
    $[2] = backwardsLabel;
    $[3] = step;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="flex-1">{t2}</div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== forwardClick || $[8] !== forwardLabel) {
    t4 = <button type="button" onClick={forwardClick}>{forwardLabel}</button>;
    $[7] = forwardClick;
    $[8] = forwardLabel;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== forwardIcon || $[11] !== forwardVariant || $[12] !== t4) {
    t5 = <div className="flex-1"><ButtonStyle iconAfter={forwardIcon} variant={forwardVariant} size="md" fullWidth={true}>{t4}</ButtonStyle></div>;
    $[10] = forwardIcon;
    $[11] = forwardVariant;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t5) {
    t6 = <div className="HelpMeChoose__footer fixed lg:relative w-full lg:w-sm bottom-0 left-0 flex-shrink-0 lg:mx-auto lg:justify-center lg:my-comfy-xl px-comfy-sm py-snug-xl flex flex-row gap-comfy-sm">{t3}{t5}</div>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};